import styled from "styled-components";
import { useState } from "react";
import NoticeListView from "features/owner/components/notice/NoticeListView";
import ViewNotice from "features/owner/components/notice/ViewNotice";
import RegisterNotice from "features/owner/components/notice/RegisterNotice";
import { hw, scrollbar } from "features/homework/homeworkUi";

const TeacherNotice = () => {
    const [isOpenRegisterModal, setIsOpenRegisterModal] = useState(false);
    const [clickedNotice, setClickedNotice] = useState({
        id: "",
        writer: "",
    });

    return (
        <Page>
            <PageHeader>
                <Title>공지사항</Title>
                <Desc>학원 공지를 확인하고 작성합니다.</Desc>
            </PageHeader>
            <RegisterNotice
                isBranch={true}
                isOpen={isOpenRegisterModal}
                onCreateConfirmClickHandler={() => setIsOpenRegisterModal(false)}
            />
            <Body>
                {clickedNotice.id ? (
                    <ViewNotice clickedNotice={clickedNotice} isBranch={true} />
                ) : (
                    <EmptyPanel>
                        <EmptyTitle>공지를 선택하세요</EmptyTitle>
                        <EmptyText>오른쪽 목록에서 제목을 누르면 내용을 확인하고 수정할 수 있습니다.</EmptyText>
                    </EmptyPanel>
                )}
                <NoticeListView
                    clickedItem={clickedNotice}
                    onNoticeClick={(id, writer) => setClickedNotice({ id, writer })}
                    isBranch={true}
                    onCreateClickHandler={() => setIsOpenRegisterModal(true)}
                />
            </Body>
        </Page>
    );
};

const Page = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 20px 24px;
`;

const PageHeader = styled.div`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 10px 16px;
    flex-shrink: 0;
`;

const Title = styled.h1`
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.03em;
    color: ${hw.text};
`;

const Desc = styled.p`
    margin: 0;
    font-size: 14px;
    color: ${hw.textMuted};
`;

const Body = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(320px, 400px);
    gap: 16px;
    flex: 1;
    min-height: 0;

    @media (max-width: 960px) {
        grid-template-columns: minmax(0, 1fr);
        overflow: auto;
        ${scrollbar}
    }
`;

const EmptyPanel = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 240px;
    padding: 24px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 16px;
    box-shadow: ${hw.shadow};
    text-align: center;
`;

const EmptyTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${hw.text};
`;

const EmptyText = styled.div`
    font-size: 13px;
    color: ${hw.textMuted};
    line-height: 1.5;
`;

export default TeacherNotice;
